import { Component, inject, input, model } from '@angular/core'
import { EventService } from 'src/app/core/services/event.service'
import { CommonModule } from '@angular/common'
import { MatIconModule } from '@angular/material/icon'
import { MatMenuModule } from '@angular/material/menu'
import { ILanguage, LanguageCode } from 'src/app/core/interfaces/language.interface'
import { MatButtonModule } from '@angular/material/button'
import { MatSelectModule } from '@angular/material/select'
import { IconButtonModule } from '../icon-button/icon-button.module'

@Component({
  selector: 'app-language-select',
  styles: [`
    @use 'sass:map';
    @import 'src/assets/globals';
    @import 'src/assets/_colors';
    @import 'src/assets/mixins';

    .selected-language {
      background-color: map-get($light, action, selected);
    }
  `],
  template: `
    @if (style() === 'button') {
      <app-icon-button
        icon-btn-small
        icon-btn-icon-large
        icon-btn-primary
        matIcon="language"
        [ariaLabel]="selectYourLanguage"
        [matMenuTriggerFor]="menu"
        data-testid="language-launch"
      />
      <mat-menu #menu="matMenu" [overlapTrigger]="false">
        @for (lang of languages(); track lang) {
          <button mat-menu-item
            (click)="handleLanguageSelect(lang.code)"
            [class.selected-language]="lang.code === selected()"
            [attr.data-lang]="lang.code"
            data-testid="language-select-button"
          >
            {{lang.name}}
          </button>
        }
      </mat-menu>
    } @else {
      <mat-form-field
        class="select select-medium select-outlined"
        [attr.aria-label]="selectYourLanguage"
      >
        <mat-select [(value)]="selected" panelClass="Currency__panel" disableRipple>
          @for (lang of languages(); track lang) {
            <mat-option
              (click)="handleLanguageSelect(lang.code)"
              [attr.data-lang]="lang.code"
              [value]="lang.code"
            >
              {{lang.name}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  `,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatSelectModule,
    IconButtonModule,
  ],
})

export class LanguageSelectComponent {
  private _eventService = inject(EventService)

  selected = model<LanguageCode>()
  languages = input.required<ILanguage[]>()
  style = input<'button' | 'dropdown'>('button')

  readonly selectYourLanguage = $localize`:@@languageSelect_MenuButtonAriaLabel:Select your language`

  handleLanguageSelect(lang: LanguageCode): void {
    this._eventService.notifyLanguageSelected(lang)
  }
}
